import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { supplierOfficeRecordQuery } from "@/app/Offices/GraphQL/supplierOfficeRecordQuery";
import { useSearch } from "@tanstack/react-router";

export function useOfficeDrawer() {
  const search = useSearch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}",
  });

  if (!search.officeId) {
    throw new Error("Office id is not present in the search params");
  }

  const { data } = useSuspenseGqlQuery(supplierOfficeRecordQuery, {
    id: search.officeId,
  });

  return data.supplierOffice;
}
